export default [
  {
    path: '/parametrizacao-template-pacote',
    component: {
      name: 'template-pacote-root',
      template: '<router-view />',
      meta: {
        resource: 'template',
        action: 'read',
        requiredAuth: true,
        breadcrumb: [
          { text: '', to: { path: '/' } },
        ],
      },
    },
    children: [
      {
        path: 'visualizar',
        name: 'template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/template/ParametrizacaoTemplatePacote.vue'),
        meta: {
          resource: 'template',
          action: 'read',
          pageTitle: 'Template de Pacotes',
          breadcrumb: [
            {
              text: 'Templates',
              to: { name: 'template-pacote' },
              active: true,
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        name: 'editar-template-pacote',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/components/cadastro-template/EditorCadastroPacote.vue'),
        meta: {
          resource: 'template',
          action: 'update',
          requiredAuth: true,
          navActiveLink: 'template-pacote',
          pageTitle: 'Template de Pacotes',
          breadcrumb: [
            {
              text: 'Templates',
              to: { name: 'template-pacote' },
            },
            {
              text: 'editar',
              to: { name: 'editar-template-pacote' },
              active: true,
            },
          ],
        },
      },
    ],
  },
]
